module.exports = __webpack_public_path__ + "img/qq.6654bb7b.jpg";